var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResend = function SvgResend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 600 600"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M186 447.471V154h132.062q28.089 0 50.728 12.158 23.06 12.157 36.055 33.54 12.997 20.962 12.997 47.793 0 27.67-12.997 49.89-12.996 21.802-35.636 34.378-22.639 12.578-51.147 12.578h-64.145v103.134zm162.667 0L274.041 314.99l72.949-10.481L430 447.471zm-94.75-157.636h57.856q10.9 0 18.866-4.612 8.385-5.03 12.577-13.835 4.612-8.804 4.612-20.123t-5.031-19.705q-5.031-8.804-14.673-13.416-9.224-4.611-22.64-4.611h-51.567z"
  })));
};
export default SvgResend;